// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as ReactIntl from "react-intl";
import * as LoadingInline from "../../components/LoadingInline/LoadingInline.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FormattedVolume from "../../components/FormattedVolume/FormattedVolume.bs.jsx";
import * as FormattedPercent from "../../components/FormattedPercent/FormattedPercent.bs.jsx";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as SectionWithHeader from "../../components/SectionWithHeader/SectionWithHeader.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import DepletedKegsModuleCss from "./DepletedKegs.module.css";

let classes = DepletedKegsModuleCss;

function DepletedKegs(props) {
  let maybeDepletedKegs = props.maybeDepletedKegs;
  let maybeFetchMoreDepletedKegs = props.maybeFetchMoreDepletedKegs;
  return <SectionWithHeader.make
    buttonsSlot={null}
    className={classes.section}
    headerId={"depleted_kegs"}
    headerSlot={"Dopité sudy"}
  >
    {maybeDepletedKegs !== undefined ? (
        maybeDepletedKegs.length !== 0 ? <>
            <table
              className={classes.table}
            >
              <thead>
                <tr>
                  <th
                    scope={"col"}
                  >
                    {"No."}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Pivo"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Objem"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Vypito"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Ztráty"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Naskladněno"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Naraženo"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Dopito"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Cena sudu"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Velké pivo"}
                  </th>
                  <th
                    scope={"col"}
                  >
                    {"Efektivita"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {maybeDepletedKegs.map(keg => {
                  let volume = keg.milliliters;
                  let kegId = Db.getUid(keg);
                  let effectivity = keg.consumptionsSum / volume;
                  let priceLargeBeer = keg.price / keg.milliliters * 500.0 | 0;
                  return <tr
                    key={kegId} >
                    <th
                      scope={"row"}
                    >
                      {keg.serialFormatted}
                    </th>
                    <td>
                      {keg.beer}
                    </td>
                    <td>
                      <FormattedVolume.make
                        milliliters={volume}
                      />
                    </td>
                    <td>
                      <FormattedVolume.make
                        milliliters={keg.consumptionsSum}
                      />
                    </td>
                    <td>
                      <FormattedVolume.make
                        milliliters={volume - keg.consumptionsSum | 0}
                      />
                    </td>
                    <td>
                      <ReactIntl.FormattedDate
                        value={keg.createdAt.toDate()}
                      />
                    </td>
                    <td>
                      <ReactIntl.FormattedDate
                        value={new Date(Stdlib_Option.getOrThrow(Db.kegFirstConsumptionTimestamp(keg), undefined))}
                      />
                    </td>
                    <td>
                      <ReactIntl.FormattedDate
                        value={Stdlib_Option.getOrThrow(Primitive_option.fromNull(keg.depletedAt), undefined).toDate()}
                      />
                    </td>
                    <td>
                      <FormattedCurrency.make
                        value={keg.price}
                      />
                    </td>
                    <td>
                      <FormattedCurrency.make
                        value={priceLargeBeer / effectivity | 0}
                      />
                    </td>
                    <td>
                      <FormattedPercent.make
                        value={effectivity * 100.0}
                      />
                    </td>
                  </tr>;
                })}
              </tbody>
            </table>
            {(
              maybeFetchMoreDepletedKegs !== undefined ? <button
                  className={Styles.button.base + ` ` + classes.fetchMoreButton}
                  type={"button"}
                  onClick={param => maybeFetchMoreDepletedKegs()}
                >
                  {"Načíst další"}
                </button> : null
            )}
          </> : <p
            className={SectionWithHeader.classes.emptyMessage}
          >
            {"Zde bude přehled dopitých sudů, zatím jste žádný nedopili 🤷‍♂️"}
          </p>
      ) : <p
        className={SectionWithHeader.classes.emptyMessage}
      >
        <LoadingInline.make />
      </p>}
  </SectionWithHeader.make>;
}

let make = DepletedKegs;

export {
  classes,
  make,
}
/* classes Not a pure module */
